import { isRequired } from 'utils/validators';

const validate = values => {
  const errors = {};

  if (isRequired(values[`description`] || '', true)) {
    errors[`description`] = 'description Is Required';
  }
  
  if (isRequired(values[`cancellation`] || '', true)) {
    errors[`cancellation`] = 'cancellationIsRequired';
  }
  
  return errors;
};

export default validate;
